module.exports = __webpack_public_path__ + "img/sixpackcarrier11.b402a10e.jpg";